import { inject, Injectable } from '@angular/core';
import { HttpService } from 'services/http/http.service';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { convertFilterStructToQueryParam } from 'utils/helpers';
import { Observable } from 'rxjs';
import {
  GeneralSharePreviewPayload,
  GeneralShareEditPayload,
  TableFilters,
  GeneralShareUpdate,
} from './general-share.interface';
import { ShowIfHttpError } from '@certemy/common';

@Injectable()
export class GeneralShareService {
  constructor(private http: HttpService) {}

  @ShowIfHttpError('Cannot receive list of employers.')
  getPreviewListOfEmployers({ certificationId, filters = new TableFilters() }): Observable<GeneralSharePreviewPayload> {
    const query = convertFilterStructToQueryParam(filters);
    return this.http.get(`/certification/${certificationId}/employer/shared?${query}`);
  }

  @ShowIfHttpError('Cannot receive list of employers.')
  getEditListOfEmployers({ certificationId, filters = new TableFilters() }): Observable<GeneralShareEditPayload> {
    const query = convertFilterStructToQueryParam(filters);
    return this.http.get(`/certification/${certificationId}/employer/shared/edit?${query}`);
  }

  @ShowIfHttpError('An error occurred while updating sharing.')
  updateSharingForEmployers(update: GeneralShareUpdate[]) {
    return this.http.put(`/certification/employer/shared`, update);
  }
}

export const generalSharePreviewResolver: ResolveFn<Observable<GeneralSharePreviewPayload>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(GeneralShareService).getPreviewListOfEmployers({ certificationId: route.params['certificationId'] });
};

export const generalShareEditResolver: ResolveFn<Observable<GeneralShareEditPayload>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(GeneralShareService).getEditListOfEmployers({ certificationId: route.params['certificationId'] });
};
